import type { Input } from '@builder.io/sdk';

export const imageField = <T extends string = 'image'>(name: T = 'image' as T, showIf?: string) =>
  ({
    name,
    type: 'object',
    subFields: [
      {
        name: 'heading',
        type: 'string',
      },
      {
        name: 'url',
        type: 'file',
      },
      {
        name: 'alt',
        type: 'string',
      },
      {
        name: 'width',
        type: 'number',
      },
      {
        name: 'height',
        type: 'number',
      },
    ],
    showIf,
  } as const satisfies DeepReadonly<Input>);

export const nextImageFields = [imageField('image')] as const satisfies DeepReadonly<Input[]>;

export type ImageConfig = GenerateBuilder<typeof nextImageFields>;

export const imageConfig = {
  name: 'HCI Image',
  inputs: nextImageFields,
};

export default imageField;
